/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import type { UINotification } from '@poweralpha/common';
import { createContext, useContext } from 'react';

export interface NotificationCenterContextValue {
  /** Opens the notification center dialog, optionally with a notification selected. */
  openNotificationCenter: (notification?: UINotification) => void;
  closeNotificationCenter: () => void;
}

export const NotificationCenterContext = createContext<NotificationCenterContextValue | undefined>(
  undefined,
);

export const useOptionalNotificationCenter = () => useContext(NotificationCenterContext);
